/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const lnhealthcenterRouter = {
	path: '/healthcenter',
	component: Layout,
	redirect: 'noRedirect',
	name: '健康',
	id: 900000,
	meta: {
		title: '健康',
		icon: 'component',
		roles: [900000]
	},
	children: [
		{
			path: 'healthpersonal',
			component: () =>
				import(
					/* webpackChunkName: "healthpersonal" */ '@/leniuview/healthCenter/healthpersonal'
				),
			name: '健康信息',
			id: 901000,
			meta: { title: '健康信息', roles: [901000] }
		},
		{
			path: 'medicalExamReport',
			name: '体检报告',
			component: LayoutView,
			id: 902000,
			meta: { title: '体检报告', roles: [902000] },
			children: [
				{
					path: 'reportTemplate',
					component: () =>
						import(
							/* webpackChunkName: "orderdetail" */ '@/leniuview/healthCenter/medicalExamReport/reportTemplate'
						),
					name: '体检报告模板',
					id: 902100,
					meta: { title: '体检报告模板', roles: [902100] }
				},
				{
					path: 'medicalExam',
					component: () =>
						import(
							/* webpackChunkName: "orderdetail" */ '@/leniuview/healthCenter/medicalExamReport/healthReport'
						),
					name: '体检报告',
					id: 902200,
					meta: { title: '体检报告', roles: [902200] }
				},
				{
					path: 'healthmonitorings',
					component: () =>
						import(/* webpackChunkName: "sick" */ '@/leniuview/healthCenterV2/medicalManagement/healthmonitorings'),
					name: '健康监测',
					id: 911000,
					meta: { title: '健康监测' }
				},
				{
					path: 'detail',
					component: () =>
						import(
							/* webpackChunkName: "orderdetail" */ '@/leniuview/healthCenter/medicalExamReport/detail'
						),
					name: '模板详情',
					meta: { title: '模板详情', noCache: true, roles: [902100] },
					hidden: true
				},
				{
					path: 'healthReportDetail',
					component: () =>
						import(
							/* webpackChunkName: "orderdetail" */ '@/leniuview/healthCenter/medicalExamReport/healthReportDetail'
						),
					name: '体检报告单',
					meta: { title: '体检报告单', noCache: true, roles: [902200] },
					hidden: true
				}
			]
		},
		{
			path: 'foodanalysis',
			component: () =>
				import(
					/* webpackChunkName: "foodanalysis" */ '@/leniuview/healthCenter/foodanalysis'
				),
			name: '摄入分析',
			id: 903000,
			meta: { title: 'healthCenter.foodanalysis', roles: [903000] }
		},
		{
			path: 'analysisdetail',
			component: () =>
				import(
					/* webpackChunkName: "analysisdetail" */ '@/leniuview/healthCenter/analysisdetail'
				),
			name: '摄入详情',
			meta: { title: '摄入详情', noCache: true, roles: [903000] },
			hidden: true
		},
		{
			path: 'partialEclipseAnalysis',
			name: '偏食分析',
			component: LayoutView,
			id: 904000,
			meta: { title: '偏食分析', roles: [904000] },
			children: [
				{
					path: 'dietaryPattern',
					component: () =>
						import(
							/* webpackChunkName: "foodanalysis" */ '@/leniuview/healthCenter/partialEclipseAnalysis/dietaryPattern'
						),
					name: '膳食宝塔模式',
					id: 904100,
					meta: { title: '膳食宝塔模式', roles: [904100] }
				},
				{
					path: 'mediterraneanSea',
					component: () =>
						import(
							/* webpackChunkName: "foodanalysis" */ '@/leniuview/healthCenter/partialEclipseAnalysis/mediterraneanSea'
						),
					name: '地中海饮食模式',
					id: 904200,
					meta: { title: '地中海饮食模式', roles: [904200] }
				},
				{
					path: 'DASH',
					component: () =>
						import(
							/* webpackChunkName: "foodanalysis" */ '@/leniuview/healthCenter/partialEclipseAnalysis/DASH'
						),
					name: 'DASH饮食模式',
					id: 904300,
					meta: { title: 'DASH饮食模式', roles: [904300] }
				}
			]
		},
		{
			path: 'healthcaipu',
			component: () =>
				import(
					/* webpackChunkName: "healthcaipu" */ '@/leniuview/healthCenter/healthcaipu'
				),
			name: '健康菜谱',
			id: 905000,
			meta: { title: 'healthCenter.healthcaipu', roles: [905000] }
		},
		{
			path: 'detail',
			component: () =>
				import(
					/* webpackChunkName: "detail" */ '@/leniuview/healthCenter/healthRecipeDetail'
				),
			name: '健康菜谱详情',
			meta: {
				title: '健康菜谱详情',
				noCache: true,
				roles: [905000]
			},
			hidden: true
		},
		{
			path: 'nutrition-recipe',
			component: () =>
				import(
					/* webpackChunkName: "healthpersonal" */ '@/leniuview/healthCenter/nutritionRecipe'
				),
			name: '营养配餐',
			id: 906000,
			meta: { title: '营养配餐', roles: [906000] }
		},
		{
			path: 'nutrition-recipe-detail',
			component: () =>
				import(
					/* webpackChunkName: "healthpersonal" */ '@/leniuview/healthCenter/nutritionRecipeDetail'
				),
			name: '配餐详情',
			meta: { title: '配餐详情', noCache: true, roles: [906000] },
			hidden: true
		},
		{
			path: 'nutritionConsultant',
			component: () =>
				import(
					/* webpackChunkName: "" */ '@/leniuview/healthCenter/nutritionConsultant'
				),
			name: '营养顾问',
			id: 907000,
			meta: { title: '营养顾问', roles: [907000] }
		},
		{
			path: 'healthConsultation',
			component: () =>
				import(
					/* webpackChunkName: "" */ '@/leniuview/healthCenter/healthConsultation'
				),
			name: '健康咨询',
			id: 908000,
			meta: { title: '健康咨询', roles: [908000] }
		},
		{
			path: 'informationsubscription',
			component: () =>
				import(
					/* webpackChunkName: "" */ '@/leniuview/healthCenter/informationsubscription'
				),
			name: '营养科普',
			id: 909000,
			meta: { title: 'healthCenter.informationsubscription', roles: [909000] }
		},
		{
			path: 'healthadvicedetail',
			component: () =>
				import(
					/* webpackChunkName: "" */ '@/leniuview/healthCenter/healthadvicedetail'
				),
			name: '营养科普详情',
			meta: {
				title: 'healthCenter.healthadvicedetail',
				noCache: true,
				roles: [909000]
			},
			hidden: true
		},
		{
			path: 'sick',
			component: () =>
				import(/* webpackChunkName: "sick" */ '@/leniuview/healthCenter/sick'),
			name: '慢性病',
			id: 910000,
			meta: { title: 'personal.sick', roles: [910000] }
		}
	]
}

export default lnhealthcenterRouter
